import moment from 'moment';
import { SharedModule } from 'primeng/api';
import { Calendar, CalendarModule } from "primeng/calendar";
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { DatePickerService } from '@shared/services/date-picker/date-picker.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'from-to-calendar',
    templateUrl: './from-to-calendar.component.html',
    standalone: true,
    imports: [DropdownModule, FormsModule, SharedModule, SpanTooltipComponent, NgClass, AfTranslateDirective, CalendarModule, ConvertDatePipe, AfTranslatePipe]
})
export class FromToCalendarComponent implements OnInit, OnChanges, AfterViewInit {

  isLanding = this.customLanding.isLanding();
  openDropdown:boolean = false;
  custom: any = this.customLanding.getCustom();
  urlPart = this.globalCfg.skin ==='steel-blue'?'be/wh/': 'denunc/';
  current: any = new Date();
  fromToCalendar: any ={
    // convertDateType: this.isLanding?'day-calendar-min':'day-calendar',
    // days: [1, 2, 3, 4, 5, 6, 7],
    ready: true,
    showCalendarMobile: 'from',
    styleButtonCancel: this.isLanding?{'border-color': this.custom.color, 'color': this.custom.color}:'',
    styleButtonApply: this.isLanding?{'background-color': this.custom.color, 'color': this.custom.textColor}:'',
    selectedMonthFrom: this.current.getMonth() + 1,
    selectedYearFrom: this.current.getFullYear(),
    selectedMonthTo: this.current.getMonth() + 1,
    selectedYearTo: this.current.getFullYear(),
    calendarOptionItem: {
      keyName: 'text',
      maxWidth: '174px',
      overlayInner: true
    },
    calendarOptionList: [
      {
        id: 0,
        text: this.translate.instant('dashboard-reports.custom-range'),
      },
      {
        id: 1,
        text: this.translate.instant('dashboard-reports.last-twelve-months'),
      },
      {
        id: 2,
        text: this.translate.instant('dashboard-reports.last-thirty-days'),
      },
      {
        id: 3,
        text: this.translate.instant('dashboard-reports.last-fifth-days'),
      },
      {
        id: 4,
        text: this.translate.instant('dashboard-reports.last-seven-days'),
      },
      {
        id: 5,
        text: this.translate.instant('dashboard-reports.this-year'),
      },
      {
        id: 6,
        text: this.translate.instant('dashboard-reports.this-quarterly'),
      },
      {
        id: 7,
        text: this.translate.instant('dashboard-reports.this-monthly'),
      },
      {
        id: 8,
        text: this.translate.instant('dashboard-reports.this-weekly'),
      }
    ],
    from: null,
    fromSave: null,
    to: null,
    toSave:null,
    selectDays: null,
    selectCalendarOption: {},
    hasError: false
  }

  constructor(private globalCfg : GlobalCfgFactory,
    private datePicker: DatePickerService,
    private translate: AfTranslateFactory,
    private customLanding: CustomLandingFactory) { }
    @ViewChild('cal') calendar!: Calendar;
    @Input() selectedPreviewOption: number = 5;
    @Input() fromSave: any = null;
    @Input() toSave: any = null;
    @Input() type: any = null;
    @Output() changeDays = new EventEmitter();
    @Output() changeCalendar = new EventEmitter();

  ngOnInit(): void {
    this.fromToCalendar.type = this.type;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.fromToCalendar.selectCalendarOption = this.fromToCalendar.calendarOptionList[this.selectedPreviewOption];
    this.fromToCalendar.from = this.fromSave !== null ? this.fromSave.toDate() : null;
    this.fromToCalendar.to = this.toSave !== null ? this.toSave.toDate(): null;
    this.configureSelectDays();
    if(this.fromToCalendar.to !== null && this.fromToCalendar.from !== null){
      this.fromToCalendar.selectDays = moment(this.fromToCalendar.to).diff(moment(this.fromToCalendar.from), 'days')+1;
      if((moment(this.fromToCalendar.to).format('DD-MMMM-YYYY') === moment(this.fromToCalendar.from).format('DD-MMMM-YYYY'))){
          this.fromToCalendar.selectDays = 1;
      }
    }
  }

  ngAfterViewInit(): void {
    if(this.fromToCalendar.type === 'report-filter-as-icam'){
      this.resetRange()
    }else if(this.fromToCalendar.type === 'dashboard-reports'){
      this.selectOption(this.fromToCalendar.calendarOptionList[1]);
    }
  }


  selectDate(dt:any, type:any){
    let selectedDate = this.datePicker.selectDate(dt, type);
    if(!this.fromToCalendar.changedCalendar && selectedDate && this.fromToCalendar.showCalendarMobile === 'from'){
      this.fromToCalendar.showCalendarMobile = 'to';
      this.fromToCalendar.changedCalendar = true;
    }
    return selectedDate;
  }

  selectOption(opt: any){
    this.fromToCalendar.selectCalendarOption = opt;
    switch(opt.id){
      case 0:
        this.resetRange();
        break;
      case 1:
        this.fromToCalendar.from = moment().subtract(1, 'year').toDate();
        this.fromToCalendar.to = moment().toDate();
        break;
      case 2:
        this.fromToCalendar.from = moment().subtract(29, 'days').toDate();
        this.fromToCalendar.to = moment().toDate();
        break;
      case 3:
        this.fromToCalendar.from = moment().subtract(14, 'days').toDate();
        this.fromToCalendar.to = moment().toDate();
        break;
      case 4:
        this.fromToCalendar.from = moment().subtract(6, 'days').toDate();
        this.fromToCalendar.to = moment().toDate();
        break;
      case 5:
        this.fromToCalendar.from = moment().startOf('year').toDate();
        this.fromToCalendar.to = moment().endOf('year').toDate();
        break;
      case 6:
        this.fromToCalendar.from = moment().startOf('quarter').toDate();
        this.fromToCalendar.to = moment().endOf('quarter').toDate();
        break;
      case 7:
        this.fromToCalendar.from = moment().startOf('month').toDate();
        this.fromToCalendar.to = moment().endOf('month').toDate();
        break;
      default:
        this.fromToCalendar.from = moment().startOf('week').toDate();
        this.fromToCalendar.to = moment().endOf('week').toDate();
        break;
    }
    if(opt.id !== 0){
      this.fromToCalendar.selectDays = moment(this.fromToCalendar.to).diff(moment(this.fromToCalendar.from), 'days')+1;
    }
    let days:any = {
      days: this.fromToCalendar.selectDays
    }
    this.changeDays.emit(days);
  }

  resetRange(){
    this.fromToCalendar.from = null;
    this.fromToCalendar.to = null;
    this.fromToCalendar.selectDays = 0;
    this.fromToCalendar.filteredCalendar = false;
    this.resetActualView();
  }

  stopEvent(type:string){
    this.fromToCalendar.hasError = false;
    this.configureSelectDays();
    if(this.fromToCalendar.type === 'dashboard-reports'){
      this.fromToCalendar.selectCalendarOption = this.fromToCalendar.calendarOptionList[0];
    }
    let days:any = {
      days: this.fromToCalendar.selectDays
    }
    this.changeDays.emit(days);
  }

  configureSelectDays(){
    if(this.fromToCalendar.to && this.fromToCalendar.from){
        let selectDays = moment(this.fromToCalendar.to).diff(moment(this.fromToCalendar.from), 'days');
        this.fromToCalendar.selectDays = selectDays >= 0?selectDays+1:selectDays;
    }else{
        this.fromToCalendar.selectDays = 0;
    }
  }

  resetActualView(){
    this.fromToCalendar.ready = false;
    setTimeout(()=>{
      this.fromToCalendar.ready = true;
    }, 100)
  }

  restore(){
    if(this.fromToCalendar.type === 'dashboard-reports'){
      this.selectOption(this.fromToCalendar.calendarOptionList[1]);
    }else{
      this.resetRange();
    }
    this.fromToCalendar.fromSave = this.fromToCalendar.from;
    this.fromToCalendar.toSave = this.fromToCalendar.to;
    this.fromToCalendar.hasError = false;
    this.fromToCalendar.showCalendarMobile = 'from';
    this.fromToCalendar.filteredCalendar = false;
    delete this.fromToCalendar.preventOptionCalendar;
    if (this.fromToCalendar.type === 'dashboard-reports') {
      this.fromToCalendar.selectCalendarOption = this.fromToCalendar.calendarOptionList[1];
    } else {
      this.fromToCalendar.selectCalendarOption = this.fromToCalendar.calendarOptionList[0];
    }
    let dates: any = {
      dates: {
          type: 'restore',
          from: this.fromToCalendar.from,
          to: this.fromToCalendar.to,
      }
    }
      this.changeCalendar.emit(dates);
  }

  cancel() {
    this.fromToCalendar.from = this.fromToCalendar.fromSave;
    this.fromToCalendar.to = this.fromToCalendar.toSave;
    this.fromToCalendar.hasError = false;
    this.configureSelectDays();
    this.resetActualView();
    this.fromToCalendar.showCalendarMobile = 'from';
    if(this.fromToCalendar.type === 'dashboard-reports' && !this.fromToCalendar.filteredCalendar){
      this.selectOption(this.fromToCalendar.calendarOptionList[1]);
    }else if(this.fromToCalendar.preventOptionCalendar){
      this.fromToCalendar.selectCalendarOption = this.fromToCalendar.preventOptionCalendar;
    }
    let dates: any = {
      dates: {
        type: 'cancel',
        from: moment(this.fromToCalendar.fromSave),
        to: moment(this.fromToCalendar.toSave),
        selectCalendarOption: this.fromToCalendar.selectCalendarOption?.id
      }
    }
      this.changeCalendar.emit(dates);
  }

  apply(){
    if(this.fromToCalendar.from?.valueOf() <= this.fromToCalendar.to?.valueOf()){
      this.fromToCalendar.hasError = false;
      this.fromToCalendar.showCalendarMobile = 'from';
      this.fromToCalendar.filteredCalendar = true;
      this.fromToCalendar.fromSave = this.fromToCalendar.from;
      this.fromToCalendar.toSave = this.fromToCalendar.to;
      this.fromToCalendar.preventOptionCalendar = this.fromToCalendar.selectCalendarOption;
      let dates: any = {
        dates: {
            type: 'apply',
            from: moment(this.fromToCalendar.from),
            to: moment(this.fromToCalendar.to),
            selectCalendarOption: this.fromToCalendar.selectCalendarOption?.id
        }
      }
        this.changeCalendar.emit(dates);
    }else{
      this.fromToCalendar.hasError = true;
    }
  }

  selectShowCalendar(type: any){
    this.fromToCalendar.showCalendarMobile = type;
  }

  getTranslateSelectDays(){
    let text = '';
    if(this.fromToCalendar.selectDays > 1){
      text = this.translate.instant('add-alert.days');
    }else if(this.fromToCalendar.selectDays === 1){
      text = this.translate.instant('add-alert.day');
    }else if(this.fromToCalendar.selectDays === null || this.fromToCalendar.selectDays === 0){
      text = this.translate.instant('dashboard-reports.select-days');
    }
    return text;
  }

  selectedDate(date:any, type:string){
    let convertDate: any = moment(date);
    let from: any = moment(this.fromToCalendar.from).format('yyyy-MM-DD')
    let to: any = moment(this.fromToCalendar.to).format('yyyy-MM-DD')
    if(type ==='from' && from){
      return convertDate.isSame(from)
    }else if(type ==='to' && to){
      return convertDate.isSame(to)
    }else{
      return false;
    }
  }

  isBetWeen(date:any){
    let convertDate: any = moment(date);
    let from: any = moment(this.fromToCalendar.from)
    let to: any = moment(this.fromToCalendar.to)
    return convertDate.isBetween(from, to) || from?.isSame(convertDate) || to?.isSame(convertDate)
  }

  // isToday(date:any){
  //   let convertDate: any = this.commonUtilsService.ngbToMoment(date);
  //   let today: any = moment();
  //   return today.format('DD-MM-yyyy') === convertDate.format('DD-MM-yyyy');
  // }

  selectDay(type: string){
    if(type === 'from'){
      this.fromToCalendar.fromDate = moment(this.fromToCalendar.from)
    }else{
      this.fromToCalendar.toDate = moment(this.fromToCalendar.to)
    }
    this.stopEvent('dashboard-reports');
  }

}
